import React, { useState } from "react";
import ImageIcons from "../components/imageComponent/ImageIcons";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  validateEmail,
  // validatePhone,
  validatePassword
} from "../utils/formFunctions";
import { IoEyeOff } from "react-icons/io5";
import { IoEye } from "react-icons/io5";
import { FaCheckCircle } from "react-icons/fa";
import Loader from "../components/shared/loader";

const Register = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState({
    email: false,
    phone: false,
    message: "",
    confirm: false,
    success: false,
  });

  const [disabled, setDisabled] = useState(false);

  // const [confirm, setConfirm] = useState('')
  const [forminput, setForminput] = useState({
    firstname: "",
    lastname: "",
    phone: "",
    email: "",
    password: "",
    confirm: "",
    address: "",
    landmark: "",
    city: "",
    district: "",
    pincode: "",
    state: "",
  });
  // const [lastname,setLastname] =useState('')
  // const [phone,setPhone] =useState('')
  // const [email,setEmail] =useState('')
  // const [password,setPassword] =useState('')
  // const [address,setAddress] =useState('')
  // const [landmark,setLandmark] =useState('')
  // const [city,setCity] =useState('')
  // const [district,setDistrict] =useState('')
  // const [pincode,setPincode] =useState('')
  // const [state,setState] =useState('')

  const firstNameHandler = (e) => {
    const inputValue = e.target.value;
    const alphaValue = inputValue.replace(/[^A-Za-z ]/g, ""); // Allow spaces
    // Capitalize the first letter of each word
    const capitalizedValue = alphaValue.replace(/\b\w/g, (match) =>
      match.toUpperCase()
    );
    if (capitalizedValue.length <= 30) {
      setForminput((prevState) => ({
        ...prevState,
        firstname: capitalizedValue,
      }));
      setError((prevState) => ({ ...prevState, message: "" }));
    }
  };

  const lastNameHandler = (e) => {
    const inputValue = e.target.value;
    const alphaValue = inputValue.replace(/[^A-Za-z]/g, "");
    if (alphaValue.length <= 30) {
      setForminput((prevState) => ({ ...prevState, lastname: alphaValue }));
      setError((prevState) => ({ ...prevState, message: "" }));
    }
  };

  const handlePhoneInputChange = (e) => {
    const inputValue = e.target.value;
    const numericValue = inputValue.replace(/\D/g, ""); // Remove non-digit characters

    if (numericValue.length <= 10) {
      setForminput((prevState) => ({ ...prevState, phone: numericValue }));
      setError((prevState) => ({ ...prevState, phone: false, message: "" }));
    }

    const repeatingDigitsRegex = /(\d)\1{9,}/;
    if (repeatingDigitsRegex.test(numericValue)) {
        // If repeating digits are found, display an error message
        setError((prevState) => ({ ...prevState, phone: true, message: "Phone number cannot consist of repeating digits." }));
    }
  };

  const addressHandler = (e) => {
    const inputValue = e.target.value;
 
    // Capitalize the first letter of each word
    
    if (inputValue.length <= 100) {
      setForminput((prevState) => ({
        ...prevState,
        address: inputValue,
      }));
      setError((prevState) => ({ ...prevState, message: "" }));
    }
  };

  const landmarkHandler = (e) => {
    const inputValue = e.target.value;
    const alphaValue = inputValue.replace(/[^A-Za-z ]/g, ""); // Allow spaces
    // Capitalize the first letter of each word
    const capitalizedValue = alphaValue.replace(/\b\w/g, (match) =>
      match.toUpperCase()
    );
    if (capitalizedValue.length <=50) {
      console.log("alphaValue", alphaValue);
      setForminput((prevState) => ({
        ...prevState,
        landmark: capitalizedValue,
      }));
      setError((prevState) => ({ ...prevState, message: "" }));
    }
  };
  const cityHandler = (e) => {
    const inputValue = e.target.value;
    const alphaValue = inputValue.replace(/[^A-Za-z ]/g, ""); // Allow spaces
    // Capitalize the first letter of each word
    const capitalizedValue = alphaValue.replace(/\b\w/g, (match) =>
      match.toUpperCase()
    );
    if (capitalizedValue.length <=50) {
      console.log("alphaValue", alphaValue);
      setForminput((prevState) => ({ ...prevState, city: capitalizedValue }));
      setError((prevState) => ({ ...prevState, message: " " }));
    }
  };
  const districtHandler = (e) => {
    const inputValue = e.target.value;
    const alphaValue = inputValue.replace(/[^A-Za-z ]/g, ""); // Allow spaces
    // Capitalize the first letter of each word
    const capitalizedValue = alphaValue.replace(/\b\w/g, (match) =>
      match.toUpperCase()
    );
    if (capitalizedValue.length <=20) {
      console.log("alphaValue", alphaValue);
      setForminput((prevState) => ({ ...prevState, district: capitalizedValue }));
      setError((prevState) => ({ ...prevState, message: " " }));
    }
  };
  const handlePincodeChange = (e) => {
    const inputValue = e.target.value;
    const numericValue = inputValue.replace(/\D/g, "");
    
    if (numericValue.length <= 6 ) {
      setForminput((prevState) => ({ ...prevState, pincode: numericValue }));
      setError((prevState) => ({ ...prevState, pincode: false, message: "" }));
    }
  };
  const stateHandler = (e) => {
    const inputValue = e.target.value;
    const alphaValue = inputValue.replace(/[^A-Za-z ]/g,""); // Allow spaces
    // Capitalize the first letter of each word
    const capitalizedValue = alphaValue.replace(/\b\w/g, (match) =>
    match.toUpperCase()
  );
    if (capitalizedValue.length <= 30) {
      setForminput((prevState) => ({ ...prevState, state: capitalizedValue }));
      setError((prevState) => ({ ...prevState, message: "" }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setDisabled(true);
    setError((prevState) => ({ ...prevState, message: "" }));
    if (
      !forminput.firstname || 
      !forminput.lastname ||
      !forminput.email ||
      !forminput.phone ||
      !forminput.password ||
      !forminput.address ||
      !forminput.landmark ||
      !forminput.city ||
      !forminput.district ||
      !forminput.pincode ||
      !forminput.state
    ) {
      setError((prevState) => ({
        ...prevState,
        success: false,
        message: "Fields must not be empty!",
      }));
      setDisabled(false);
    } else if (!validateEmail(forminput.email)) {
      setError((prevState) => ({
        ...prevState,
        email: true,
        message: "Email is invalid!",
      }));
      setDisabled(false);
    } else if (forminput.phone.length < 10) {
      setError((prevState) => ({
        ...prevState,
        phone: true,
        message: "Phone number is invalid!",
      }));
      setDisabled(false);
    }
    else if (/^(\d)\1*$/.test(forminput.phone)) {
      setError((prevState) => ({
        ...prevState,
        phone: true,
        message: "Phone number must be valid !",
      }));
      setDisabled(false);

    } else if (!validatePassword(forminput.password)) {
      setError((prevState) => ({
        ...prevState,
        password: true,
        message:
          "Password should contain atleast 8 characters and must contain one uppercase, one lowercase, one digit and one special character!",
      }));
      setDisabled(false);
    } else if (forminput.password !== forminput.confirm) {
      setError((prevState) => ({
        ...prevState,
        confirm: true,
        message: "Confirm Password should be same as Password!",
      }));
      setDisabled(false);
    } else if (forminput.pincode === '000000') {
      setError((prevState) => ({
        ...prevState,
        pincode: true,
        message: "Pincode cannot be 0. Please enter a valid pincode.",
      }));
      setDisabled(false);
    } else if (forminput.pincode.length < 6) {
      setError((prevState) => ({
        ...prevState,
        pincode: true,
        message: "Pincode is invalid!",
      }));
      setDisabled(false);
    }
     else if (forminput.pincode.charAt(0) === '0') {
    setError((prevState) => ({
      ...prevState,
      pincode: true,
      message: "Pincode cannot start with '0'. Please enter a valid pincode.",
    }));

    setDisabled(false);
  }  else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_URL}user/adduser`,
          {
            firstName: forminput.firstname,
            lastName: forminput.lastname,
            phone: forminput.phone,
            email: forminput.email,
            password: forminput.password,
            confirm: forminput.confirm,
            address: forminput.address,
            landmark: forminput.landmark,
            city: forminput.city,
            district: forminput.district,
            pincode: forminput.pincode,
            state: forminput.state,
          }
        );
        if (response.data) {
          setTimeout(() => {
            setError((prevState) => ({ ...prevState, success: false }));
            setDisabled(false);
            setForminput({
              firstname: "",
              lastname: "",
              phone: "",
              email: "",
              password: "",
              confirm: "",
              address: "",
              landmark: "",
              city: "",
              district: "",
              pincode: "",
              state: "",
            });
          }, 3000);
        }
        setError((prevState) => ({ ...prevState, success: true }));

        console.log("response", response);

      } catch (error) {
        console.log("error",error)
        setError(prevState => ({ ...prevState, message: error.response.data }));


        setDisabled(false);
      }
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <>
      <section className="p-0 flex max-md:flex-wrap h-[100vh] h-100">
        <div
          className='w-[35%] max-md:w-full relative bg-cover bg-center bg-no-repeat text-center py-[8%] max-md:py-[50px] after:absolute after:content-[""] after:w-full after:h-full after:left-0 after:top-0 after:opacity-60 after:bg-[linear-gradient(157deg,#f48533_15%,#3308d3_100%)]'
          style={{ height: '100%', backgroundImage: `url(${ImageIcons.registerImg})` }}
        >
          <div className="relative z-40 text-center">
            <Link className="inline-block mb-[20px]" to="/">
              <img
              
                className="m-auto drop-shadow-[0_0_10px_#00000052]"
                src={ImageIcons.logo}
                alt="Logo"
              />
            </Link>
            <h2 className="text-white drop-shadow-[0_0_5px_#00000052] mb-0">
              Register Now
            </h2>
          </div>
        </div>
        {error.success ? (
          <div className="lg:w-[100%] text-center p-[40] my-[40px]">
            <div className="">
              <h2 className="]">Thank You For Register</h2>
              {/* <p className='text-[20px] text-[#f38432] font-bold ml-[500px]'>You have been Successfully Registered on MyInternet</p> */}
              <FaCheckCircle
                sx={{ fontSize: "400px", color: "#d5763b" }}
                className="mt-[40px] text-7xl inline "/>
              <p className="text-[20px] text-[#f38432] font-bold mt-[50px] lg:w-[37.8%] m-auto">
                You have been Successfully Registered on MyInternet
              </p>
            </div>
          </div>
        ) : (
          <>
            
          {disabled && <Loader/>}
            <form className="grid sm:grid-cols-2 grid-cols-1 items-center gap-[20px] w-[65%] max-md:w-full lg:py-[50px] py-[40px] lg:px-[80px] sm:px-[30px] px-[20px] overflow-y-auto relative">
              <p
                className={`text-[14px] mb-0 text-[#FF0000] font-semibold sm:col-span-2 col-span-1  ${
                  error.message ? "block" : "hidden "
                }`}
              >
                {error.message}
              </p>
              <div>
                <label className="mb-[8px] inline-block" htmlFor="firstName">
                  First Name
                </label>
                <input
                  id="firstName"
                  disabled={disabled}
                  value={forminput.firstname}
                  onChange={(e) => firstNameHandler(e)}
                  className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                />
              </div>
              <div>
                <label className="mb-[8px] inline-block" htmlFor="lastName">
                  Last Name
                </label>
                <input
                  id="lastName"
                  disabled={disabled}
                  value={forminput.lastname}
                  onChange={(e) => lastNameHandler(e)}
                  className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                />
              </div>
              <div>
                <label className="mb-[8px] inline-block" htmlFor="phone">
                  Phone
                </label>
                <input
                  id="phone"
                  disabled={disabled}
                  value={forminput.phone}
                  onChange={(e) => handlePhoneInputChange(e)}
                  className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                />
              </div>
              <div>
                <label className="mb-[8px] inline-block" htmlFor="email">
                  Email
                </label>
                <input
                  id="email"
                  disabled={disabled}
                  value={forminput.email}
                  onChange={(e) => {
                    setForminput((prevState) => ({
                      ...prevState,
                      email: e.target.value,
                    }));
                    setError((prevState) => ({
                      ...prevState,
                      email: false,
                      message: "",
                    }));
                  }}
                  className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                />
              </div>
              <div>
                <label className="mb-[8px] inline-block" htmlFor="password">
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    disabled={disabled}
                    value={forminput.password}
                    onChange={(e) => {
                      setForminput((prevState) => ({
                        ...prevState,
                        password: e.target.value,
                      }));
                      setError((prevState) => ({
                        ...prevState,
                        password: false,
                        message: "",
                      }));
                    }}
                    className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                  />
                  <button
                    type="button"
                    className="absolute right-[20px] top-[16px] text-[20px] text-[#f48533] cursor-pointer"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <IoEyeOff /> : <IoEye />}
                  </button>
                </div>
              </div>
              <div>
                <label className="mb-[8px] inline-block" htmlFor="confirm">
                  Confirm Password
                </label>
                <div className="relative">
                  <input
                    name="confirm"
                    disabled={disabled}
                    id="confirm"
                    type={showConfirmPassword ? "text" : "password"}
                    value={forminput.confirm}
                    onChange={(e) => {
                      setForminput((prevState) => ({
                        ...prevState,
                        confirm: e.target.value,
                      }));
                      setError((prevState) => ({
                        ...prevState,
                        confirm: false,
                        message: "",
                      }));
                    }}
                    className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                  />
                  <button
                    type="button"
                    className="absolute right-[20px] top-[16px] text-[20px] text-[#f48533] cursor-pointer"
                    onClick={toggleConfirmPasswordVisibility}
                  >
                    {showConfirmPassword ? <IoEyeOff /> : <IoEye />}
                  </button>
                </div>
              </div>
              <div>
                <label className="mb-[8px] inline-block" htmlFor="address">
                  Address
                </label>
                <input
                  id="address"
                  disabled={disabled}
                  value={forminput.address}
                  onChange={(e) => addressHandler(e)}
                  
                  className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                />
              </div>
              <div>
                <label className="mb-[8px] inline-block" htmlFor="landmark">
                  Landmark
                </label>
                <input
                  id="landmark"
                  disabled={disabled}
                  value={forminput.landmark}
                  onChange={(e) => landmarkHandler(e)}
                  className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                />
              </div>
              <div>
                <label className="mb-[8px] inline-block" htmlFor="city">
                  City
                </label>
                <input
                  id="city"
                  disabled={disabled}
                  value={forminput.city}
                  onChange={(e) => cityHandler(e)}
                  className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                />
              </div>
              <div>
                <label className="mb-[8px] inline-block" htmlFor="district">
                  District
                </label>
                <input
                  id="district"
                  disabled={disabled}
                  value={forminput.district}
                  onChange={(e) => districtHandler(e)}
                  className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                />
              </div>
              <div>
                <label className="mb-[8px] inline-block" htmlFor="pinCode">
                  Pin Code
                </label>
                <input
                  id="pinCode"
                  disabled={disabled}
                  value={forminput.pincode}
                  onChange={(e) => handlePincodeChange(e)}
                  className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                />
              </div>
              <div>
                <label className="mb-[8px] inline-block" htmlFor="state">
                  State
                </label>
                <input
                  id="state"
                  disabled={disabled}
                  value={forminput.state}
                  onChange={(e) => stateHandler(e)}
                  className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                />
              </div>
              <div className="text-center sm:col-span-2">
                <button
                  onClick={handleSubmit}
                  className="px-[30px] text-[18px] py-[12px] max-sm:w-full duration-500 text-[#fff] bg-[#f48533] rounded-[10px] hover:bg-[#000] ease inline-block sm:min-w-[400px] min-w-full"
                  type="submit"
                >
                  Submit Message
                </button>

                <p className="text-center sm:mt-[30px] mt-[20px] mb-0">
                  Already have an an account?{" "}
                  <Link className="text-[#f48533] underline" to="/login">
                    LogIn
                  </Link>
                </p>
              </div>
            </form>
          </>
        )}
      </section>
    </>
  );
};
export default Register;